export default {"src":"/_next/static/media/LocationPackageIcon.9cd57532.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};